// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EnterpriseCoordinatorDiagnosisServiceModelsDiagnosisSessionModel {
    'diagnosisIds'?: Array<number>;
    'diagnosisCodes'?: Array<string>;
    'delimitedCodes'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EnterpriseCoordinatorDiagnosisServiceModelsDiagnosisSessionModel>> = [
        {
            "name":     "diagnosisIds",
            "baseName": "diagnosisIds",
            "type":     "Array<number>"
        },
        {
            "name":     "diagnosisCodes",
            "baseName": "diagnosisCodes",
            "type":     "Array<string>"
        },
        {
            "name":     "delimitedCodes",
            "baseName": "delimitedCodes",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return EnterpriseCoordinatorDiagnosisServiceModelsDiagnosisSessionModel.attributeTypeMap;
    }
}
